"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _formik = require("formik");

var _yup = require("yup");

var _reactRedux = require("react-redux");

var _notistack = require("notistack");

var _dialog = _interopRequireDefault(require("../../../_common/dialog"));

var _fullScreen = _interopRequireDefault(require("../../../_common/dialog/fullScreen"));

var _customField = _interopRequireDefault(require("../../../_common/formik/customField"));

var _recaptcha = _interopRequireDefault(require("../../../_common/recaptcha"));

var _actions = require("../../../../redux/locations/actions");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FeedbackDialog = function FeedbackDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      location = _ref.location;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      verified = _useState2[0],
      setVerified = _useState2[1];

  var submitRef = (0, _react.useRef)(null);
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var actions = /*#__PURE__*/_react.default.createElement("div", {
    className: "flex justify-end"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginRight10"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "default",
    onClick: onClose
  }, "Cancel")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "primary",
    disabled: !verified,
    onClick: function onClick() {
      return submitRef.current.click();
    }
  }, "Submit")));

  var form = /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    initialValues: {
      email: '',
      feedback: ''
    },
    onSubmit: function onSubmit(_ref2) {
      var email = _ref2.email,
          feedback = _ref2.feedback;
      console.log("onSubmit triggered!!");

      if (verified) {
        dispatch((0, _actions.submitLocationFeedback)(location.id, location.name, feedback, email, enqueueSnackbar));
        onClose();
      }
    },
    validationSchema: (0, _yup.object)().shape({
      email: (0, _yup.string)().email("Please enter a valid email").required("Email is required"),
      feedback: (0, _yup.string)().required("Feedback is required")
    })
  }, /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "submit",
    style: {
      display: "none"
    },
    ref: submitRef
  }), /*#__PURE__*/_react.default.createElement("div", null, "Please fill in the details below and it will be reviewed and updated if applicable. Please contact the site directly with any antibody therapy specific questions.", /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), "You will not receive a response from the NICA team unless you are a site administrator and need assistance with personally claiming or updating the profile."), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "feedback",
    label: "Feedback",
    multiline: true,
    placeholder: "Enter your message here",
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "email",
    type: "email",
    label: "email",
    placeholder: "sue.smith@gmail.com",
    fullWidth: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop30"
  }, /*#__PURE__*/_react.default.createElement(_recaptcha.default, {
    onChange: function onChange(_) {
      return setVerified(true);
    }
  }))));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    xsDown: true
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: open,
    onClose: onClose,
    title: "Location Data Feedback",
    actions: actions
  }, form)), /*#__PURE__*/_react.default.createElement(_Hidden.default, {
    smUp: true
  }, /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    open: open,
    title: "Location Data Feedback",
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_AppBar.default, {
    position: "static"
  }, /*#__PURE__*/_react.default.createElement(_Toolbar.default, null, "Location Data Feedback")), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "20px"
    }
  }, form, /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, actions))))));
};

var _default = FeedbackDialog;
exports.default = _default;